module.exports = __webpack_public_path__ + "img/logo-small-light.7480f594.png";